"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var label_1 = require("../label");
exports.default = (function (_a) {
    var theme = _a.theme, className = _a.className, title = _a.title, onAction = _a.onAction, actionIconName = _a.actionIconName;
    return (React.createElement("div", { className: classnames_1.default(theme["panel-header"], className) },
        React.createElement(label_1.Label, { className: theme.label, uppercase: true, size: 13, spacing: 1.25 }, title),
        actionIconName ? (React.createElement("div", { className: theme.action, onClick: onAction },
            React.createElement(icon_1.Icon, { iconName: actionIconName, size: 1.8 }))) : null));
});
